import toast from '../../components/ui/toast/toast';
import Notification from '../../components/ui/Notification';
import { removeItem, setDiscountCode } from '../../store/basket/basketSlice';

// Owner, 2026-10-07: the server refused the applied coupon for this cart and
// said why (a coupon limited to menus). Drop the code and the lines THAT
// coupon added, and tell the customer in the server's words. Not through
// useCouponValidation.removeCoupon: that one needs its async `appliedCoupon`,
// which is null on the payment page and right after an apply.
// A line belongs to the refused coupon when it is stamped with its code
// (`couponCode`, set where the handler adds a coupon's line). The code is the
// gate: Remove in the coupon modal takes the current code's lines the same way
// (CouponModal.handleClear), so no flagged line outlives its code; a line
// stamped with another code is never taken. Lines without a stamp (older
// persisted baskets) are never removed by a refusal or by Remove.
export const couponLines = (items, code) =>
  (items || []).filter(
    (item) =>
      Boolean(code) &&
      item.couponCode === code &&
      (item.isFreeItemFromCoupon === true || Boolean(item.bxgyInfo)),
  );

export const dropCouponWithReason = (dispatch, items, reason, code) => {
  couponLines(items, code).forEach((item) =>
    dispatch(removeItem(item.basketId)),
  );
  dispatch(setDiscountCode(''));
  toast.push(
    <Notification title="Coupon not applied" type="danger" duration={4000}>
      {reason}
    </Notification>,
    { placement: 'top-center' },
  );
};
